import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslationKeys } from '../TranslationKeys';

@Injectable({ providedIn: 'root' })
export class TranslateHelperService {
    public readonly Keys = TranslationKeys;

    public constructor(private _translateService: TranslateService) {}

    public translate(key: string | Array<string>) {
        return this._translateService.instant(key);
    }

    public translateAsync(key: string | Array<string>) {
        return this._translateService.get(key);
    }
}